import React from 'react';
import ScreeningComposerPage from 'components/ScreeningComposer/ScreeningComposerPage';
import { IMPORT_PROFILE } from 'components/ScreeningComposer/profiles';

const ImportScreeningComposer: React.FC = () => (
  <ScreeningComposerPage profile={IMPORT_PROFILE} />
);

export default ImportScreeningComposer;
